var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("app-custom-language-select", {
                        staticClass: "mr",
                        style: { flexGrow: "1" },
                        attrs: { value: _vm.lang },
                        on: {
                          input: function ($event) {
                            return _vm.setLang($event)
                          },
                          "copy-to-all-languages": _vm.copyToAllLanguages,
                        },
                      }),
                      _c(
                        "w-button-bar",
                        [
                          _c(
                            "w-dropdown",
                            {
                              attrs: { items: _vm.buttonBarItems, right: "" },
                              on: {
                                click: function ($event) {
                                  return $event()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "bars" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-sortable",
            {
              attrs: {
                items: _vm.headingItems,
                tag: "div",
                "target-class": "handle",
              },
              on: {
                drop: function ($event) {
                  return _vm.onSorted()
                },
              },
            },
            _vm._l(_vm.headingItems, function (item, num) {
              return _c(
                "w-row",
                { key: num, staticClass: "value-button" },
                [
                  _c(
                    "w-col",
                    [
                      _c("w-fa", {
                        staticClass: "handle",
                        attrs: { icon: "ellipsis-v" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    [
                      _c("w-input", {
                        attrs: {
                          label: _vm.$ct("line", { num: num + 1 }),
                          fancy: "",
                        },
                        model: {
                          value: item.Value.Translations[_vm.lang],
                          callback: function ($$v) {
                            _vm.$set(item.Value.Translations, _vm.lang, $$v)
                          },
                          expression: "item.Value.Translations[lang]",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct(`tooltip.style-edit`),
                              expression: "$ct(`tooltip.style-edit`)",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editStyle(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "font", size: "lg" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("isShown") },
            model: {
              value: _vm.heading.Show,
              callback: function ($$v) {
                _vm.$set(_vm.heading, "Show", $$v)
              },
              expression: "heading.Show",
            },
          }),
        ],
        1
      ),
      _vm.toEditStyleHeading
        ? _c(
            "w-modal",
            { attrs: { value: _vm.toEditStyleHeading != null } },
            [
              _c("app-style-editor", {
                attrs: {
                  "preview-text":
                    _vm.toEditStyleHeading.Value.Translations[_vm.lang],
                  value: _vm.toEditStyleHeading.Style,
                },
                on: {
                  close: function ($event) {
                    _vm.toEditStyleHeading = null
                  },
                  input: function ($event) {
                    _vm.toEditStyleHeading.Style = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("app-all-layouts-select", {
        attrs: {
          title: _vm.$ct("apply-heading-to-other-layouts"),
          show: _vm.allLayoutsSelectModalOpen,
          "confirm-handler": _vm.applyHeadingToOtherLayoutsHandler,
        },
        on: {
          close: function ($event) {
            _vm.allLayoutsSelectModalOpen = false
          },
        },
      }),
      _vm.conditionsEditModalOpen
        ? _c("app-conditions-edit-modal", {
            attrs: { fields: _vm.fields },
            on: {
              close: function ($event) {
                _vm.conditionsEditModalOpen = false
              },
            },
            model: {
              value: _vm.heading.Conditions,
              callback: function ($$v) {
                _vm.$set(_vm.heading, "Conditions", $$v)
              },
              expression: "heading.Conditions",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }